import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { TableIcon16Solid } from "../../../../../icons2022/FileTypeTableIcon/TableIcon16Solid";
import { TableIcon20Solid } from "../../../../../icons2022/FileTypeTableIcon/TableIcon20Solid";
import { TableIcon24Solid } from "../../../../../icons2022/FileTypeTableIcon/TableIcon24Solid";
export var TableIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(TableIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(TableIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(TableIcon24Solid, null);
  }
}, 'TableIcon');